import { ItmsChallasEnum, JunctionStatus, Operation, PriorityEnum } from "./Enum.types";
import { idAndFlagType } from "./formTypes";
import {
  ItmsChallasOptionsTypes,
  JunctionStatusOptionsTypes,
  msgType,
  PriorityOptionsTypes,
  TicketStatusOptionsTypes,
} from "./types";

export const query = "/query";

export const EMPTY_STRING = "";
export const INPUT = "INPUT";
export const BUTTON = "BUTTON";
export const SELECT = "SELECT";
export const TEXTAREA = "TEXTAREA";
export const DELETE = "DELETE";
export const FETCH_MORE_DATA = 5;
export const ROWS_PER_PAGE = 25;
export const TEN_ROWS = 10;
export const CARDS_ROWS_PER_PAGE = 20;
export const debouncedDelay = 500;

export const MULTI_SELECT_LIMIT_TAGS = 1;
export const DEFAULT_TIME = "1970-01-01";

export const imageFormats = ["jpg", "jpeg", "png", "xlsx", "xls", "csv"];
export const videoFormats = ["mp4", "webm"];

export const docFormat = ["docx", "doc", "pdf"];

export const allowedFormatsForTicket = [...imageFormats, ...videoFormats];

export const allowedFormatsForMom = [...imageFormats, ...docFormat];

export const AutocompleteInput = "MuiInputBase-input";

export const emptyMessage: msgType = {
  flag: false,
  message: "",
  operation: Operation.NONE,
};

export enum UserType {
  USER = "USER",
  CASHIER = "CASHIER",
  EDUATE = "EDUATE",
  PARENT = "PARENT",
  EMPLOYEE = "EMPLOYEE",
  OWNER = "OWNER",
  STUDENT = "STUDENT",
  TEACHER = "TEACHER",
  SYS_ADMIN = "SYS_ADMIN",
  ADM_EXECUTIVE = "ADM_EXECUTIVE",
  CLERK = "CLERK",
  ACCOUNTANT = "ACCOUNTANT",
}

export const WIDTH = [0, 1, 2, 3, 4, 5];

export const emptyFunc = () => {};

export enum EnvAccessType {
  DEV = "DEV",
  PROD = "PROD",
}

export enum TicketStatus {
  OPEN = "OPEN",
  ASSIGNED = "ASSIGNED",
  RESOLVED = "RESOLVED",
  CLOSED = "CLOSED",
  RE_OPENED = "RE_OPENED",
  EXEMPTED = "EXEMPTED",

  ALL = "ALL",
}

export const ticketStatusOptions: TicketStatusOptionsTypes[] = [
  {
    value: TicketStatus.OPEN,
    label: "Open",
  },
  {
    value: TicketStatus.ASSIGNED,
    label: "Assigned",
  },
  {
    value: TicketStatus.RESOLVED,
    label: "Resolved",
  },
  {
    value: TicketStatus.CLOSED,
    label: "Closed",
  },
  {
    value: TicketStatus.RE_OPENED,
    label: "Re Opened",
  },
];

export const junctionStatusOptions: JunctionStatusOptionsTypes[] = [
  {
    value: JunctionStatus.PLANNED,
    label: "Planned",
  },
  {
    value: JunctionStatus.WORK_IN_PROGRESS,
    label: "Work In Progress",
  },
  {
    value: JunctionStatus.INSTALLED,
    label: "Installed",
  },
  {
    value: JunctionStatus.SHIFTING,
    label: "Shifting",
  },
  {
    value: JunctionStatus.COMMISSIONED,
    label: "Commissioned",
  },
  {
    value: JunctionStatus.DECOMMISSIONED,
    label: "Decommissioned",
  },
  {
    value: JunctionStatus.NOT_WORKING,
    label: "Not Working / Not Operational",
  },
];

export const getTicketStatusOption = (value: TicketStatus) => {
  const option = ticketStatusOptions.find((option) => option.value === value);
  return option ? option.label : "";
};

export const ticketPriorirityOptions: PriorityOptionsTypes[] = [
  {
    value: PriorityEnum.CRITICAL,
    label: "Critical",
  },
  {
    value: PriorityEnum.LOW,
    label: "Low",
  },
  {
    value: PriorityEnum.MEDIUM,
    label: "Medium",
  },
  {
    value: PriorityEnum.MAJOR,
    label: "Major",
  },
];



  const ItmsChallasOptions: ItmsChallasOptionsTypes[] = [
    {
      value: ItmsChallasEnum.BIAL,
      label: "BIAL",
    },
    {
      value: ItmsChallasEnum.ITMS,
      label: "ITMS",
    }
  ];

export const getTicketPriorityOption = (value: PriorityEnum) => {
  const option = ticketPriorirityOptions.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};

export const WINDOW_MIN_WIDTH = 960;
export const WINDOW_MIN_HEIGHT = 600;
export const WINDOW_MAX_ZOOM = 2.5;

export const emptyOpType = {
  flag: false,
  operation: Operation.NONE,
};

export const emptyIdAndModal: idAndFlagType = {
  flag: false,
  id: 0,
};

export const DEFAULT_LATITUDE = 12.981010391578677;
export const DEFAULT_LONGIYUDE = 77.60151962452281;

export const ticketRaiseResonOptions = [
  "Signal Off",
  "Aspect Not Working",
  "Timer Not Working",
  "POPA Not Working",
  "Signal Timing Issue",
  "Accident and Damage",
  "Others",
];

export const pollingMinutes = 60 * 1000;
